let radioInputs = document.querySelectorAll(".options__select_new option");
const selects = document.querySelectorAll(".options__select_new");
const titleMain = document.querySelector(".product_title_h1 span");
const titleMain02 = document.querySelector(".product_title_h1_new span");

const optionsItem = document.querySelector(".options__option span");
const optionsItemSpan222 = document.querySelectorAll(
  ".selection__option_new label input"
);

let resizeTimerNew;

function getCheckedValues() {
  const checkedInputs = Array.from(radioInputs).filter(
    (input) => input.selected
  );
  console.log(Array.from(radioInputs), "23");
  const checkedValues = checkedInputs.map((input) => input.value).join(",");
  const splitValue = checkedValues ? "," : "";
  let titleUp = optionsItem
    ? optionsItem.innerHTML + splitValue
    : "" + checkedValues;

  if (window.innerWidth > 1199) {
    titleMain.innerHTML = titleUp;
    return titleMain.innerHTML;
  } else {
    titleMain02.innerHTML = titleUp;
    return titleMain02.innerHTML;
  }
}

function handleOptionChange(event) {
  const checkedInputs02 = Array.from(radioInputs).filter(
    (input) => input.selected
  );
  const selectedInputs02 = Array.from(optionsItemSpan222)
    .map((item, index) => {
      if (item.checked == true) {
        return item.value;
      }
    })
    .filter((value) => value !== undefined);

  const checkedValues02 = checkedInputs02.map((input) => input.value).join(",");
  const combinedValues = selectedInputs02.concat(checkedValues02).join("");
  const splitValue = checkedValues02 ? "," : "";
  let titleUp = optionsItem
    ? optionsItem.innerHTML + splitValue
    : "" + checkedValues02;

  if (window.innerWidth > 1199) {
    titleMain.innerHTML = titleUp;
    return titleMain.innerHTML;
  } else {
    titleMain02.innerHTML = titleUp;
    return titleMain02.innerHTML;
  }
}

function handleOptionChange02(event) {
  const selectedValue = event.target.value;
  const correspondingOptionItem = optionsItem[event.target.selectedIndex];

  if (correspondingOptionItem) {
    correspondingOptionItem.innerHTML = selectedValue;
  }

  const checkedInputs02 = Array.from(radioInputs).filter(
    (input) => input.selected
  );

  const checkedValues02 = checkedInputs02.map((input) => input.value).join(",");
  const splitValue = checkedValues02 ? "," : "";

  let titleUp = selectedValue + splitValue + checkedValues02;
  if (window.innerWidth > 1199) {
    titleMain.innerHTML = titleUp;
    return titleMain.innerHTML;
  } else {
    titleMain02.innerHTML = titleUp;
    return titleMain02.innerHTML;
  }
}

selects.forEach((select, index) => {
  select.addEventListener("change", handleOptionChange);
});

optionsItemSpan222.forEach((item, index) => {
  item.addEventListener("change", handleOptionChange02);
});

radioInputs.forEach((input) => {
  input.addEventListener("change", getCheckedValues);
});

getCheckedValues();

window.addEventListener("resize", function () {
  if (window.innerWidth === 1199) {
    location.reload();
    getCheckedValues();
  }
});
